import { ReactNode } from 'react'
import { LayoutCard, LayoutCardProps } from '../layout-card'
import { LayoutTwoSections, LayoutTwoSectionsProps } from '../layout-two-sections'

interface Props extends Omit<LayoutCardProps, 'className'>, Pick<LayoutTwoSectionsProps, 'scrollableSections'> {
  rightContainer: ReactNode
  className: string
}

export const LayoutTwoSectionsCard = ({ children, rightContainer, className, scrollableSections, ...props }: Props) => {
  return (
    <LayoutCard fullHeight {...props}>
      <LayoutTwoSections className={className} rightContainer={rightContainer} scrollableSections={scrollableSections}>
        {children}
      </LayoutTwoSections>
    </LayoutCard>
  )
}
